// noop
export const SectionPaddingClassName = "py-30px md:py-50px lg:py-75px";
export const SectionPaddingTopClassName = "pt-50px lg:pt-75px";
export const SectionPaddingBottomClassName = "pb-50px lg:pb-75px";
export const SectionMarginTopClassName = "mt-50px lg:mt-75px";
export const SlidePaddingClassName = "py-50px";

export const MainWidthClassName =
  "col-start-2 col-span-4 md:col-start-2 md:col-span-8 lg:col-start-3 lg:col-span-12";
export const HalfWidthClassName =
  "col-start-2 col-span-4 md:col-start-2 md:col-span-4 lg:col-start-3 lg:col-span-6";
export const MainShortWidthClassName =
  "col-start-2 col-span-4 md:col-start-2 md:col-span-7 lg:col-start-3 lg:col-span-9";
export const MainWideTextClassName =
  "col-start-2 col-span-4 md:col-start-3 md:col-span-7 lg:col-start-6 lg:col-span-9";
export const HalfWidthTextClassName =
  "col-start-3 col-span-3 md:col-start-5 md:col-span-5 lg:col-start-8 lg:col-span-7";
export const SecondaryWidthClassName =
  "col-start-2 col-span-4 md:col-start-3 md:col-span-6 lg:col-start-4 lg:col-span-10";

export const SlideHeightClassName = "h-855px";
export const MinSlideHeightClassName = "min-h-855px";

export const HeadingRTFOverrides = {
  h1: "h3",
  h2: "h3",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
};

export const AllHeadingRTFOverrides = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
};

export const P1RTFOverrides = {
  ...HeadingRTFOverrides,
  p: "p1",
  div: "p1",
};

export const P2RTFOverrides = {
  ...HeadingRTFOverrides,
  p: "p2",
  div: "p2",
};
export const P3RTFOverrides = {
  ...HeadingRTFOverrides,
  p: "p3",
  div: "p3",
};

export const P3AllRTFOverrides = {
  ...AllHeadingRTFOverrides,
  p: "p3",
  div: "p3",
};

export const P4RTFOverrides = {
  ...AllHeadingRTFOverrides,
  p: "p4",
  div: "p4",
};
